export default __webpack_public_path__ + "static/media/styleisland.baafbe2a.jpg";